export const calculateRootMeanSquaredError = (errorSum) => {
    // Error sum is multiplied by 16 within the firmware and a 'deci value'
    // Round to 2 decimal places by multiplying the decivalue by 10 and then dividing by 100
    const rootMeanSquaredError = Math.round(Math.sqrt(errorSum / 16) * 10) / 100;
    if (isNaN(rootMeanSquaredError) || !isFinite(rootMeanSquaredError))
        return 0;
    return rootMeanSquaredError;
};
